import { startOfMonth } from "date-fns";
import { IReclamationFormValues } from "./interface";

interface UserCNPJ {
  BpID?: string;
  CNPJ?: string;
}

export const getInitialValues = (
  userCNPJList: UserCNPJ[] = []
): IReclamationFormValues => ({
  ref_id: "",
  cnpj: userCNPJList
    .map((ele) => ele.BpID || ele.CNPJ)
    .filter((cnpj): cnpj is string => !!cnpj),
  startDate: startOfMonth(new Date()),
  endDate: new Date(),
  date_range: [startOfMonth(new Date()), new Date()],
});

export const initialValuesFomik: IReclamationFormValues = {
  ref_id: "",
  cnpj: [],
  startDate: startOfMonth(new Date()),
  endDate: new Date(),
  date_range: [startOfMonth(new Date()), new Date()],
};
